import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import ParameterInline from "@/components/multiedit/temporary/ParameterInline.vue";
import { ParameterInstanceContainer } from "@/models/interfaces/parameters/parameter-models";
import { useModalEscape } from "@/composables/useModalEscape";

type ParameterExpandModalProps = {
	id: string,
	title: string,
	modelValue: ParameterInstanceContainer[],
	editable?: boolean,
	tokenStyles?: Record<string, string>,
	showFieldLabel?: boolean,
	loading?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ParameterExpandModal',
  props: {
    id: {},
    title: {},
    modelValue: {},
    editable: { type: Boolean, default: false },
    tokenStyles: {},
    showFieldLabel: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "refresh"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)
const $content = ref<HTMLElement | null>(null)
// Таблица нужна параметру как якорь контекстного меню, поэтому он рендерится вторым проходом
const $table = ref<HTMLElement | null>(null)

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose()
})

const onOpen = () => {
	$modal.value?.onOpen()
	activateEsc()
}
const onClose = () => $modal.value?.onClose()

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: props.title,
    loading: props.loading,
    width: "max-content",
    "max-width": "90vw",
    height: "max-content",
    onOnClose: _unref(deactivateEsc)
  }, {
    "header-right": _withCtx(() => [
      _createVNode(AppTooltip, {
        text: _ctx.$t('refresh_label')
      }, {
        activator: _withCtx(() => [
          _createVNode(AppIcon, {
            name: "refresh",
            width: "16px",
            color: "#979797",
            "hover-color": "#499259",
            cursor: "pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('refresh')))
          })
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "parameter-expand"
      }, [
        _createElementVNode("table", {
          class: "dialog-table",
          ref_key: "$table",
          ref: $table
        }, [
          ($table.value)
            ? (_openBlock(), _createBlock(ParameterInline, {
                key: 0,
                "is-root": "",
                "is-table": "",
                editable: props.editable,
                id: props.id,
                "model-value": props.modelValue,
                "token-styles": props.tokenStyles,
                "show-custom": false,
                "value-set-from-instance": true,
                "context-trigger": $table.value,
                "create-mode": false,
                "show-field-label": props.showFieldLabel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emit('update:modelValue', value))
              }, null, 8, ["editable", "id", "model-value", "token-styles", "context-trigger", "show-field-label"]))
            : _createCommentVNode("", true)
        ], 512)
      ], 512)
    ]),
    _: 1
  }, 8, ["title", "loading", "onOnClose"]))
}
}

})